const variables = {
  // basic
  colorBackground: '#f8f8f8',
  colorShadow: '#eeeeed',
  colorHeader: '#979ea8',
  colorTitle: '#73757a',
  colorSubtext: '#5e656d',
  colorText: '#222b35',
  // green
  colorGreenLightest: '#d0fbe1',
  colorGreenLighter: '#95edb9',
  colorGreenLight: '#4ad07f',
  colorGreenPrimary: '#98ce32',
  colorGreenDark: '#0b7334',
  // blue
  colorBlueLightestTs: '',
  colorBlueLighterTs: '#96e5fc',
  colorBlueLightTs: '#48c0e9',
  colorBluePrimaryTs: '#55a5e7',
  colorBlueDarkTs: '#006ab7',
  // yellow
  colorYellowLighter: '#ffea9c',
  colorYellowLight: '#ffd331',
  colorYellowPrimary: '#fca100',
  colorYellowDark: '#e1de00',
  // orange
  colorOrangeLightest: '',
  colorOrangeLighter: '',
  colorOrangeLight: '',
  colorOrangePrimary: '#f06021',
  colorOrangeDark: '#d43d00',
  colorOrangeDarker: '#b57701',
  // purple
  colorPurpleLightest: '',
  colorPurpleLighter: '',
  colorPurpleLight: '#cdabff',
  colorPurplePrimary: '#8946ec', // #ae78ff, not sure, 2 colors in scss
  colorPurpleDark: '#6b31c2',
  // pink
  colorPinkLightest: '',
  colorPinkLighter: '',
  colorPinkLight: '#f7a0fb',
  colorPinkPrimary: '#d450da', // #f076f5, not sure, 2 colors in scss
  colorPinkDark: '#97289c',
  // red
  colorRedPrimary: '#f06021',
  colorRedDark: '#d43d00',
  colorRedDarker: '#a11010',
  // gray
  colorGrayLightest: '#f7f7f7',
  colorGrayLighter: '#e2e2e2',
  colorGrayLight: '#d5d5d5',
  colorGrayPrimary: '#bfbfbf',
  colorGrayDark: '#aaa',
  colorGrayDarker: '#353535',

  colorHighlight: '#f6c134',
  colorHighlightBackground: '#f8c000'
};

export const colors = {
  text: {
    background: variables.colorBackground,
    shadow: variables.colorShadow,
    header: variables.colorHeader,
    title: variables.colorTitle,
    subtext: variables.colorSubtext,
    text: variables.colorText
  },
  green: {
    lightest: variables.colorGreenLightest,
    lighter: variables.colorGreenLighter,
    light: variables.colorGreenLight,
    primary: variables.colorGreenPrimary,
    dark: variables.colorGreenDark
  },
  blue: {
    lightest: variables.colorBlueLightestTs,
    lighter: variables.colorBlueLighterTs,
    light: variables.colorBlueLightTs,
    primary: variables.colorBluePrimaryTs,
    dark: variables.colorBlueDarkTs
  },
  yellow: {
    lighter: variables.colorYellowLighter,
    light: variables.colorYellowLight,
    primary: variables.colorYellowPrimary,
    dark: variables.colorYellowDark
  },
  orange: {
    lightest: variables.colorOrangeLightest,
    lighter: variables.colorOrangeLighter,
    light: variables.colorOrangeLight,
    primary: variables.colorOrangePrimary,
    dark: variables.colorOrangeDark,
    darker: variables.colorOrangeDarker
  },
  purple: {
    lightest: variables.colorPurpleLightest,
    lighter: variables.colorPurpleLighter,
    light: variables.colorPurpleLight,
    primary: variables.colorPurplePrimary,
    dark: variables.colorPurpleDark
  },
  pink: {
    lightest: variables.colorPinkLightest,
    lighter: variables.colorPinkLighter,
    light: variables.colorPinkLight,
    primary: variables.colorPinkPrimary,
    dark: variables.colorPinkDark
  },
  red: {
    primary: variables.colorRedPrimary,
    dark: variables.colorRedDark,
    darker: variables.colorRedDarker
  },
  gray: {
    lightest: variables.colorGrayLightest,
    lighter: variables.colorGrayLighter,
    light: variables.colorGrayLight,
    primary: variables.colorGrayPrimary,
    dark: variables.colorGrayDark,
    darker: variables.colorGrayDarker
  },
  special: {
    expected: variables.colorGrayLighter,
    highlight: variables.colorHighlight,
    highlightBg: variables.colorHighlightBackground
  }
};
